import { render, staticRenderFns } from "./PartnerHome.vue?vue&type=template&id=c9d16b94&"
import script from "./PartnerHome.vue?vue&type=script&lang=js&"
export * from "./PartnerHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports